import navigateCheckout from './navigateCheckout'
import scrollToFirstError from './scrolltoFirstError'

export default {
    mixins: [navigateCheckout, scrollToFirstError],

    props: {
        checkoutData: {
            type: Object,
            required: true
        },
        componentName: {
            type: String,
            required: true
        },
        currentComponent: {
            type: String,
            required: true
        },
        currentStep: {
            type: Number,
            required: true
        },
    },

    computed: {
        componentNameInKebab() {
            return this.componentName
                .replace(/([a-z0-9])([A-Z])/g, '$1-$2')
                .replace(/([A-Z])([A-Z])(?=[a-z])/g, '$1-$2')
                .toLowerCase()
        },
        portalAvailable() {
            return 'PortalTarget' in this.$options.components
        }
    },

    created() {
        this.$bus.$on('checkout-step-navigated', (event) => {
            if (event.to !== this.componentName) {
                return
            }

            this.$nextTick(() => {
                this.$bus.$once('after-transition', (to) => {
                    this.scrollToSection(to)
                })
            })
        })
    },

    mounted() {
        this.$bus.$on('checkout-step-navigated', (event) => {
            if (event.from === this.componentName) {
                this.onNavigatedFrom(event.to)
            }

            if(event.to === this.componentName) {
                this.onNavigatedTo(event.from)
            }
        })
    },

    methods: {
        scrollToSection(to) {
            const options = {
                easing: 'ease-in-out',
                offset: 0 - this.$attrs['scroll-top-offset'],
                force: true,
                cancelable: true,
                behavior: 'smooth',
            }

            this.$scrollTo(
                '#id-'+to,
                this.$attrs['scroll-duration'],
                options
            )
        },

        onNavigatedFrom() {
            // to
        },
        onNavigatedTo() {
            // from
        }
    }
}
